import React from "react";
import "../../styles/gstr.scss";
type AppProps = {
  data: any;
  gst?: boolean;
  // | {
  //     gstIn?: string | undefined;
  //     label: string;
  //     legalName?: string | undefined;
  //     value: number;
  //   }
  // | { value: string; label: string };
};
const GstrThreeBAutoFilledTable = ({ data, gst }: AppProps) => {
  return (
    <div className="table-bordered col-md-12 gstr">
      <table className='table table-striped"'>
        <tbody>
          <tr>
            <td className="left-table-columns col-md-4">1. GSTIN</td>
            <td className="col-md-8">{data?.gstIn ? data?.gstIn : "NA"}</td>
          </tr>

          <tr>
            <td className="left-table-columns col-md-4">
              2(a). Legal name of the registered person
            </td>
            <td className="col-md-8">
              {data?.legalName ? data?.legalName : "NA"}
            </td>
          </tr>

          <tr>
            <td className="left-table-columns col-md-4">
              2(b). Trade name, if any
            </td>
            <td className="col-md-8">
              {!gst
                ? data?.label !== "Select Branch" &&
                  data?.label !== "Select GST No."
                  ? data?.label
                  : "NA"
                : data?.label !== "Select Branch" &&
                  data?.label !== "Select GST No."
                ? data?.tradeName
                : "NA"}
            </td>
          </tr>

          <tr>
            <td className="left-table-columns col-md-4">2(c). ARN</td>
            <td className="col-md-8">NA</td>
          </tr>

          <tr>
            <td className="left-table-columns col-md-4">2(d). Date of ARN</td>
            <td className="col-md-8">NA</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GstrThreeBAutoFilledTable;
